// The Hive PRODUCTION web build (netcup server, *.bee-king.eu tenants).
// Same relative-URL topology as environment.netcup.ts: the SPA is served on
// <tenant>.bee-king.eu and Traefik rewrites /@/ per tenant, so backend URLs
// must stay relative. The native mobile flavor (absolute URLs from
// .env.production) remains the plain `production` configuration.
export const environment = {
  production: true,
  apiBaseUrl: '/@/backend/api/v1',
  graphqlBaseUrl: '/@/backend/graphql/',
  storageBaseUrl: '/@/backend/uploads/',
  // The bee-king TENANT hosts proxy /@/backend but NOT /@/materials — verified on
  // production 2026-08-27: bananas.bee-king.eu/@/materials 404s while
  // api.bee-king.eu/@/materials 401s (routed, wants auth). Same topology as dev.
  // The tenant-neutral API host already allows the tenant origins via CORS, and the
  // tenant still travels in the X-Company-Uuid header, not the hostname.
  materialsApiUrl: 'https://api.bee-king.eu/@/materials/api/v1',
  // TODO: replace with a production-restricted Maps key. This is the shared
  // billing-enabled key (macs-fe's, and beeking's dev/staging/netcup/local). The
  // value that was here has NO billing on its Cloud project, so every map loaded
  // greyed out under the "For development purposes only" watermark.
  mapsKey: 'AIzaSyD3BSb_bws8mMLG85TKOeQE00znsYVG8DI',
  appVersion: '1.0.2',
  auth: {
    kcIssuer: 'https://auth.beequeen.app/realms/macs-clients',
    kcClientId: 'macs-spa-clients',
    kcRedirectUri: 'eu.beethere.mobile:/oauth2redirect',
    kcScopes: 'openid profile email offline_access',
    currentUserPath: '/control_center/users/current',
  },
  // Feature availability is DATA, not inferred from `production`. It used to be
  // `!production`, which silently hid Materials on the deployed dev server too,
  // because that build sets production: true for its optimisations.
  features: {
    materials: true,
  },
  // Demo mode. Enabled only in the purpose-built demo configuration
  // (environment.demo.ts) and in non-production dev builds — see
  // core/config/feature-flags.ts. Never reachable from a production bundle.
  demo: {
    enabled: false,
    autoStart: false,
    magicLinkHash: '',
  },
};
